import React from 'react';
import ImagePicker from '../../../Components/ImagePicker/ImagePicker';
import './AdminForm.css'; // Az új, közös CSS importálása

const MetaEditor = ({ meta, onFormChange }) => {
    return (
        <div className="editor-card">
            <h3>Oldal Meta Adatok</h3>

            <div className="form-group">
                <div className="label-wrapper">
                    <label htmlFor="site-title">Oldal Címe</label>
                    <span className="label-description">A böngésző fülén és a keresési eredményekben megjelenő cím.</span>
                </div>
                <input 
                    id="site-title"
                    type="text" 
                    value={meta.title}
                    onChange={(e) => onFormChange('siteMeta.title', e.target.value)}
                />
            </div>

            <div className="form-group">
                <div className="label-wrapper">
                    <label htmlFor="site-desc">Oldal Leírása</label>
                    <span className="label-description">A keresőmotorok által megjelenített rövid leírás (meta description).</span>
                </div>
                <textarea 
                    id="site-desc"
                    rows="3"
                    value={meta.description}
                    onChange={(e) => onFormChange('siteMeta.description', e.target.value)}
                />
            </div>

            <hr />
            
            <h3>Közösségi Média Megosztás</h3>

            <div className="form-group">
                <div className="label-wrapper">
                    <label htmlFor="og-title">OG Cím</label>
                    <span className="label-description">A cím, ami a Facebook/Twitter megosztásoknál jelenik meg.</span>
                </div>
                <input 
                    id="og-title"
                    type="text" 
                    value={meta.ogTitle}
                    onChange={(e) => onFormChange('siteMeta.ogTitle', e.target.value)}
                />
            </div>

            <div className="form-group">
                <div className="label-wrapper">
                    <label htmlFor="og-desc">OG Leírás</label>
                    <span className="label-description">A megosztásoknál megjelenő leírás.</span>
                </div>
                <textarea 
                    id="og-desc"
                    rows="3"
                    value={meta.ogDescription}
                    onChange={(e) => onFormChange('siteMeta.ogDescription', e.target.value)}
                />
            </div>

            <div className="form-group">
                 <div className="label-wrapper">
                    <label>OG Kép</label>
                    <span className="label-description">Ajánlott méret: 1200x630px.</span>
                </div>
                <ImagePicker 
                    value={meta.ogImage}
                    onChange={(newValue) => onFormChange('siteMeta.ogImage', newValue)}
                />
            </div>
            
            <div className="form-group">
                 <div className="label-wrapper">
                    <label>Favicon</label>
                    <span className="label-description">Ikon a böngésző fülén (.ico, .png, .svg).</span>
                </div>
                <ImagePicker 
                    value={meta.favicon}
                    onChange={(newValue) => onFormChange('siteMeta.favicon', newValue)}
                />
            </div>

        </div>
    );
};

export default MetaEditor;